import {formatPhoneNumber} from 'platform/locale';

import {reject, isNil} from 'ramda';

import {CustomerResponseBodyV2} from '@dms/api/customer';
import {PhoneNumber} from '@dms/api/shared';

import {isNotNilOrEmpty, Nullish} from 'shared/web';

const formatNumber = (phone: PhoneNumber) =>
  isNotNilOrEmpty(phone?.prefix) && isNotNilOrEmpty(phone?.number)
    ? formatPhoneNumber(`${phone?.prefix}${phone?.number}`)
    : null;

export const getCustomerPhoneNumbers = (customer: CustomerResponseBodyV2 | Nullish) => {
  const businessPhoneNumbers = customer?.contacts.flatMap((contact) =>
    contact.phoneNumbers.flatMap(formatNumber)
  );

  const foundingPersonPhoneNumbers = customer?.foundingPerson?.phoneNumbers.map((phone) =>
    formatNumber(phone)
  );

  const contractInformationPhoneNumbers = customer?.contractInformation.flatMap((contract) =>
    contract.person?.phoneNumbers.flatMap(formatNumber)
  );

  const phoneNumbers =
    customer?.discriminator === 'BUSINESS'
      ? businessPhoneNumbers
      : [
          ...(foundingPersonPhoneNumbers ?? []),
          ...(contractInformationPhoneNumbers ?? []),
          ...(businessPhoneNumbers ?? []),
        ];

  const uniquePhoneNumbers = new Set(reject(isNil, phoneNumbers ?? []));

  return Array.from(uniquePhoneNumbers).map((phone) => ({value: phone, label: phone}));
};
